/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    generateGradeAcademicTranscriptApi,
    getAcademicTranscriptGradePreviewDataApi,
    // generateAcademicTranscriptApi,
    getGradeLatestAcademicTranscriptApi,
    // downloadAcademicTranscriptApi,
} from "@/api/reportingApi";
import { AcademicTranscriptPreviewInterface } from "@/ts/interfaces/Reporting/AcademicTranscriptPreviewInterface";
import { mapAcademicTranscriptPreviewApiData } from "@/utils/reportingDataMapper";

// 1) Preview (maps raw -> typed preview)
export const fetchAcademicTranscriptGradePreviewThunk = createAsyncThunk<
    { data: AcademicTranscriptPreviewInterface },
    { student: number; productFamilyGradeId: number; },
    { rejectValue: string }
>("reporting/gradeAcademicTranscript/preview", async ({ student, productFamilyGradeId }, { rejectWithValue }) => {
    try {
        const { data: { data: raw } } = await getAcademicTranscriptGradePreviewDataApi(student, productFamilyGradeId);
        const data = mapAcademicTranscriptPreviewApiData(raw);
        return { data };
    } catch (e: any) {
        return rejectWithValue(e?.message ?? "Failed to fetch preview");
    }
});

// // 2) Generate (return raw)
export const generateGradeAcademicTranscriptThunk = createAsyncThunk<
    { data: any },
    { studentId: number; productFamilyGradeId: number; year: number },
    { rejectValue: string }
>("reporting/gradeAcademicTranscript/generate", async ({ studentId, productFamilyGradeId, year }, { rejectWithValue }) => {
    try {
        const { data } = await generateGradeAcademicTranscriptApi(studentId, productFamilyGradeId, year);
        return { data };
    } catch (e: any) {
        return rejectWithValue(e?.message ?? "Failed to generate academic transcript");
    }
});

// 3) Latest (return raw)
export const getGradeLatestAcademicTranscriptThunk = createAsyncThunk<
    { data: any },
    { studentId: number; productFamilyGradeId: number; },
    { rejectValue: string }
>("reporting/gradeAcademicTranscript/latest", async ({ studentId, productFamilyGradeId }, { rejectWithValue }) => {
    try {
        const { data } = await getGradeLatestAcademicTranscriptApi(studentId, productFamilyGradeId);
        return { data };
    } catch (e: any) {
        return rejectWithValue(e?.message ?? "Failed to fetch latest academic transcript");
    }
});

// // 4) Download (return raw)
// export const downloadAcademicTranscriptThunk = createAsyncThunk<
//     { data: any },
//     { asset: number },
//     { rejectValue: string }
// >("reporting/academicTranscript/download", async ({ asset }, { rejectWithValue }) => {
//     try {
//         const { data } = await downloadAcademicTranscriptApi(asset);
//         return { data };
//     } catch (e: any) {
//         return rejectWithValue(e?.message ?? "Failed to download academic transcript");
//     }
// });
